// extracted by mini-css-extract-plugin
export default {"contentWrapper":"PagePlaceholder_contentWrapper__+7DEg","pageWrapper":"PagePlaceholder_pageWrapper__57IEt","contentHeader":"PagePlaceholder_contentHeader__3fNTs"};